import { User } from "../gateway/User/User";

export class AuthenticateUserUsecase {
    constructor() {
        this.UserGateway = new User();
    }

    async execute({ email = "", password = "" } = {}) {
        const payload = this.sanitizeInput({ email, password });
        if (!payload.email) return null;
        if (!payload.password) return null;
        try {
            const response = await this.UserGateway.authenticate(
                payload.email,
                payload.password
            );
            if (["Error", "AuthenticationError"].includes(response.name))
                throw new Error(response.message);
            return response;
        } catch (error) {
            throw new Error(`${error.message || "Falha na autenticação"}`);
        }
    }

    sanitizeInput({ email = "", password = "" } = {}) {
        const sanitizedEmail = String(email).trim();
        const sanitizedPassword = String(password);
        return {
            email: sanitizedEmail,
            password: sanitizedPassword
        };
    }
}
